import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';
import defaultSettings from '../../config/defaultSettings';


// 生成uuid
export const createStandardUuid = () => {
  return uuidv4();
}
export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const weekday = date.getDay();
  return `${year}年${month}月${day}日 星期${weekday}`;
}
// 获取当前时间戳
// 获取当前时间，返回 yyyy-mm-dd hh:mm:ss 格式
export const getTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
// 生成随机字符串
export const generateRandomString = (length = 16) => {
  const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters[randomIndex];
  }
  return result;
}
// aes加密
export const aesEncrypt = (data) => {
  let key = CryptoJS.enc.Utf8.parse(defaultSettings.aes_key)
  let iv = CryptoJS.lib.WordArray.random(16)
  let encrypted = CryptoJS.AES.encrypt(data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(iv) +'|'+ encrypted.toString()
}
// aes解密
export const aesDecrypt = (params) => {
  let paramsArr = params.split("|")
  // 秘钥,转换成utf8格式字符串，用于加密解密，一般长度是16位（由后端提供）
  let key = CryptoJS.enc.Utf8.parse(defaultSettings.aes_key)
  // 偏移量，转换成utf8格式字符串，一般长度是16位(由后端提供)
  let iv = CryptoJS.enc.Base64.parse(paramsArr[0])
  let decrypt = CryptoJS.AES.decrypt(paramsArr[1], key, {
    iv,							// 偏移量
    mode: CryptoJS.mode.CBC,		// 模式（五种加密模式，各有优缺）
    padding: CryptoJS.pad.Pkcs7	// 填充
  })
  // 转成utf8格式字符串，并返回出去
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr
}
// 数据签名
export const dataSign = (data) => {
  console.log('dataSign', data)
  // 按照键名排序
  const sortedKeys = Object.keys(data).sort();
  let str = ''
  for (let index = 0; index < sortedKeys.length; index++) {
    let key = sortedKeys[index];
    let val = data[key];
    // 跳过sign字段和空值 还有空对象和空数组
    if (!val || key == 'sign' || val == '{}') {
      console.log('跳过sign字段和空值', key, val)
      continue
    }
    // // data.data 为空对象的时候 不参与签名加密
    // if (key === 'data' && Object.keys(val).length === 0) {
    //   console.log('data.data 为空对象，不参与签名')
    //   continue
    // }
    str +=key + '=' + val + '&'
  }
  let sign_key = defaultSettings.sign_key;
  str += 'signKey='+ sign_key
  // 序列化排序后的键值对
  console.log('dataSignstr', str)
  return CryptoJS.MD5(str).toString()
}
// export const dataSign = (data) => {
//     // 按照键名排序
//     const sortedKeys = Object.keys(data).sort();
//     // 构建参数数组，跳过sign字段和空值
//     const arr = [];
//     sortedKeys.forEach(key => {
//         if (key === 'sign') return;
//         let val = data[key];
//         if (val === null || val === undefined || val === '') return;
//         if (typeof val === 'object') {// 跳过空对象和空数组
//             if (Object.keys(val).length === 0) return;
//             if (Array.isArray(val) && val.length === 0) return;
//             val = JSON.stringify(val);
//         }
//         arr.push(`${key}=${val}`);
//     });
//     let sign_key =  defaultSettings.sign_key;
//     // 拼接字符串并添加signKey
//     const signStr = arr.join("&") + `&signKey=${sign_key.trim() || sign_key}`;
//     console.log("待签名字符串:", signStr);
//     // 计算MD5
//     return CryptoJS.MD5(signStr).toString();
// }
